import createReactComponent from '../createReactComponent';
export default createReactComponent('currency-taka', 'IconCurrencyTaka', [
  ['path', { d: 'M16.5 15.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0', key: 'svg-0' }],
  ['path', { d: 'M7 7a2 2 0 1 1 4 0v9a3 3 0 0 0 6 0v-.5', key: 'svg-1' }],
  ['path', { d: 'M8 11h6', key: 'svg-2' }],
]);
